export const VisitPhysician = {
    path: '/visits/physician',
    name: 'visits.physician',
    component: () => import('@/views/Visit/VisitPhysicianPage.vue'),
    children: [
        {
            path: '/visits/physician/view/:id',
            name: 'visits.physician.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'physician'}
        },
        {
            path: '/visits/physician/customer/view/:id',
            name: 'visits.physician.customer.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'physician'},
        },
    ]
}